<script>
import { mapStores } from "pinia";

import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import NotificationService from "@/common/notification.service";
import IconHelp from "@/components/icons/IconHelp.vue";
import SupportForm from "@/components/support/SupportForm.vue";
import { useAuthStore } from "@/stores";

export default {
  name: "SupportModal",
  components: {
    IconHelp,
    SupportForm,
    TgModal
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  computed: {
    ...mapStores(useAuthStore)
  },
  methods: {
    afterSubmit() {
      this.$emit("close");

      NotificationService.success(this.$t("supportForm.submitted"));
    }
  }
};
</script>

<template>
  <TgModal :is-open="isOpen" @close="$emit('close')">
    <template #modal-header>
      <IconHelp role="presentation" class="support-modal__icon-help mr-2" />
      <p class="mb-0">{{ $t("supportModal.title") }}</p>
    </template>

    <div class="container pb-4 support-modal">
      <div>
        <p class="support-modal__greeting mb-2 mt-3">
          {{
            $t("supportModal.greeting", {
              username: authStore.userDisplayName
            })
          }}
        </p>
        <h1 class="support-modal__heading mb-4">
          {{ $t("supportModal.needHelp") }}
          <img class="emoji" src="https://abc.ordbogen.com/emoji/wave.svg" />
        </h1>
      </div>
      <SupportForm @submitted="afterSubmit()" />
    </div>
  </TgModal>
</template>
